<template>
  <div class="d-flex align-center">
    <v-badge bordered overlap offset-y="20" offset-x="20" :content="count.toString()" id="cart-badge">
      <v-btn icon @click="showCart" id="show-cart">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </v-badge>
  </div>
</template>

<script>

export default {
  name: "CartMenu",
  methods: {
    showCart() {
      this.$emit("show-cart");
    }
  },
  props: {
    count: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>

</style>